import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  isLargeScreen,
  isLargeScreenFun,
  updateCustomTableHeaders,
} from '../../../../global.variable';

import { DataCheckService } from '../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { OrientationLockService } from '../../../shared/services/orientationlock.service';
import { IncidentsService } from './incidents.service';

@Component({
  selector: 'gtapp-incidents',
  templateUrl: './incidents.component.html',
  styleUrl: './incidents.component.scss',
  standalone: false,
})
export class IncidentsComponent implements OnInit {
  incidentListData: any = [];

  previousIncidents: number = 0;
  rowsIncidents: number = 10;
  pageNumIncidents: number = 1;
  totalPagesIncidents: number = 0;
  sortKeyIncidents: any;
  searchParamsIncidents: any;
  incidentCountStats: any = {};
  otherParamsIncidents: any = {
    apiFiltering: true,
  };

  incidentDropDownList: any = [];

  globalFilter: any;

  incidentListTableDetails: any = [];
  incidentCardDetails: any = {
    individualDetails: [],
    groupDetails: (row: any) => {
      if (!row?.submitted_at) {
        return {
          'font-weight': '600',
        };
      }

      return {};
    },
  };

  largeView: Boolean = isLargeScreen;
  isLargeScreenSubscription: Subscription = new Subscription();

  tabNames: any = {
    tab1: 'Incidents',
    tab2: 'Resolved',
  };

  selectedFilter: string = 'default';

  isDispatchUser = this.dataCheckService.isDispatchUser();
  isAdmin = this.dataCheckService.isUserAdmin();
  constructor(
    private spinnerService: LoadingSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private dataCheckService: DataCheckService,
    private incidentService: IncidentsService,
    private orientationService: OrientationLockService,
  ) {
    this.formatRouteUrl();
    this.getTableDetails();
  }
  ngOnDestroy() {
    this.isLargeScreenSubscription?.unsubscribe();
  }
  ngOnInit(): void {
    this.isLargeScreenSubscription =
      this.orientationService.isLargeScreen.subscribe(async (event: any) => {
        if (event) {
          this.largeView = await isLargeScreenFun();
        }
      });

    this.getIncidents();
  }

  onIncidentLookup(event: any) {
    if (event.target.value.length > 3) {
      this.incidentService
        .getIncidents({}, { search_str: event.target.value })
        .subscribe((res: any) => {
          if (res['status'] == 'success') {
            this.incidentDropDownList = res?.data;
          }
        });
    }
  }

  addIncident() {
    this.router.navigate(['/add-incident'], {
      relativeTo: this.route,
    });
  }

  onSelectIncident(event: any) {
    this.spinnerService.show();

    if (
      ((event?.status === 0 && event?.submitted_at) || event?.status === 1) &&
      (this.isAdmin || this.isDispatchUser)
    ) {
      this.router.navigate(['/review-incident', { inKey: String(event?.id) }]);
    } else {
      this.router.navigate(['/view-incident', { inKey: String(event?.id) }]);
    }
  }

  getIncidentsCount(reqParams: any, body: any) {
    let params: any = { get_count: 1, ...reqParams };

    this.incidentService
      .getIncidents(body, params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.otherParamsIncidents = {
            ...this.otherParamsIncidents,
            paginationData: {
              totalRows: response?.total_count,
              previousRows: this.previousIncidents,
              rows: this.rowsIncidents,
              pageNum: this.pageNumIncidents,
              totalPages: this.totalPagesIncidents,
            },
          };
          this.incidentCountStats = response;

          if (response?.incident_count === 0) {
            this.addIncident();
          }
        }
      });
  }
  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParamsIncidents,
          otherParams: this.otherParamsIncidents,
          selectedFilter: this.selectedFilter,
        }),
      ),
      queryParams: {},
      replaceUrl: true,
    });
  }
  getIncidents(getCount = true) {
    let params: any = {};
    let body: any = {};
    this.spinnerService.show();

    if (this.selectedFilter !== 'all') {
      if (
        this.selectedFilter === 'default' &&
        !(this.isAdmin || this.isDispatchUser)
      ) {
        this.selectedFilter = 'open';
      }
      params.selected_filter = this.selectedFilter;
    }

    if (this.rowsIncidents) {
      params['rows'] = this.rowsIncidents;
    }
    if (this.previousIncidents) {
      params['previous'] = this.previousIncidents;
    }
    if (this.sortKeyIncidents) {
      params['sort_key'] = this.sortKeyIncidents;
    }
    if (this.globalFilter) {
      params['search_str'] = this.globalFilter;
    }

    if (this.searchParamsIncidents) {
      body.ui_filters = this.searchParamsIncidents;
    }

    if (getCount) this.getIncidentsCount(params, body);

    this.incidentService
      .getIncidents(body, params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.incidentListData = response?.data;
          this.updateRoutPath();
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  onChangePaginationIncident(data: any) {
    this.previousIncidents = data?.paginationData?.previousRows;
    this.pageNumIncidents = data?.paginationData?.pageNum;
    this.rowsIncidents = data?.paginationData?.rows;

    this.otherParamsIncidents.paginationData = {
      ...data?.paginationData,
      fixedRows: true,
    };
    this.getIncidents(false);
  }
  sortColumnIncident(body: any) {
    this.sortKeyIncidents = body?.sortList || [];
    this.searchParamsIncidents = body?.searchParams || {};
    this.getIncidents(false);
  }
  searchColumnIncident(event: any) {
    this.searchParamsIncidents = event?.searchParams || {};
    this.pageNumIncidents = 1;
    this.previousIncidents = 0;
    this.getIncidents();
  }

  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));
      if (urlFragmentDetails && Object.keys(urlFragmentDetails)?.length) {
        this.searchParamsIncidents = {
          ...this.searchParamsIncidents,
          ...(urlFragmentDetails?.searchParams || {}),
        };

        this.selectedFilter = urlFragmentDetails?.selectedFilter || 'default';
        this.globalFilter = urlFragmentDetails?.globalFilter || '';
        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previousIncidents =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previousIncidents;
          this.pageNumIncidents =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNumIncidents;
          this.rowsIncidents =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.rowsIncidents;
        }
      }
    } catch (error) {}
  }
  getTableDetails() {
    let mobileCardDetails = [
      {
        nestedValue: (row: any) => {
          return row?.status == 0
            ? row?.submitted_at
              ? 'Report Not Sent' // Resolved, not sent
              : 'In Progress' // Open not yet resolved
            : 'Completed'; // Sent
        },
        conditionalRowStyle: (row: any) => {
          if (row?.status === 0) {
            // Resolved - report not sent out
            if (row?.submitted_at) {
              return {
                'background-color': 'var(--bs-white)',
                'color': 'var(--bs-success)',
                'border': '1px solid',
                'border-radius': '5px',
                'padding': '0 0.5rem',
                'float': 'right',
                'font-size': 'small',
                'text-align': 'center',
                'white-space': 'pre-line',
                'vertical-align': 'initial',
              };
            } else {
              // 'In Progress' Open not yet resolved
              return {
                'background-color': 'var(--bs-white)',
                'color': 'var(--bs-primary)',
                'border': '1px solid',
                'border-radius': '5px',
                'padding': '0 0.5rem',
                'float': 'right',
                'font-size': 'small',
                'text-align': 'center',
                'white-space': 'pre-line',
                'vertical-align': 'initial',
              };
            }
          } else {
            // Completed and report sent
            return {
              'background-color': 'var(--bs-success)',
              'color': 'var(--bs-white)',
              'border': '1px solid',
              'border-radius': '5px',
              'padding': '0 0.5rem',
              'float': 'right',
              'font-size': 'small',
              'text-align': 'center',
              'white-space': 'pre-line',
              'vertical-align': 'initial',
            };
          }
        },
      },

      {
        name: 'incident_type',
      },

      {
        name: 'site_name',
        cardRowStyle: { 'font-weight': 'bold' },
        suffixStyle: { 'font-weight': 'normal' },
        suffixNestedValue: (row: any) => {
          return ` [${row?.company_name}]`;
        },
      },

      // Address
      {
        name: 'full_address',
        cardRowStyle: { 'font-size': 'small' },
      },
      {
        name: 'incident_time',
        datetimeObj: true,
        cardRowStyle: { float: 'right' },
      },
    ];
    let tableDetails = [
      {
        header: 'Reported',
        name: 'incident_time',
        datetimeObj: true,
        sortKey: 'incident_time',
        // suffixNestedValue: (row: any) => {
        //   return row?.incident_type ? `\n[${row?.incident_type}]` : null;
        // },
        // suffixStyle: { 'white-space': 'pre-line' },
      },

      {
        header: 'Incident Type(s)',
        name: 'incident_type',
      },

      {
        header: 'Site',
        name: 'site_name',
        sortKey: 'site__company_name',
        searchKey: 'site__company_name',
        tableColumnStyle: {
          'white-space': 'pre-line',
        },
        suffixNestedValue: (row: any) => {
          return `\n[${row?.company_name}]`;
        },
        suffixStyle: { 'font-size': 'small' },
      },

      {
        header: 'Address',
        name: 'full_address',
        sortKey: 'full_address',
        searchKey: 'full_address',
      },

      {
        header: 'Reference No.',
        name: 'incident_key',
        searchKey: 'incident_key',
      },
      {
        header: 'Status',
        // dateRangeKey: 'submitted_at',
        // sortKey: 'submitted_at',
        nestedValue: (row: any) => {
          return row?.status == 0
            ? row?.submitted_at
              ? 'Report Not Sent' // Resolved, not sent
              : 'In Progress' // Open not yet resolved
            : 'Completed'; // Sent
        },
        // suffixNestedValue: (row: any) => {
        //   return row?.submitted_at
        //     ? `\n ${formatDateTimeStamp(row?.submitted_at, 'd MMM y HH:mm', 'en_Us')}`
        //     : null;
        // },
        suffixStyle: {
          'white-space': 'pre-line',
        },
        conditionalColumnStyle: (row: any) => {
          if (row?.status === 0) {
            // Resolved - report not sent out
            if (row?.submitted_at) {
              return {
                'background-color': 'var(--bs-white)',
                'color': 'var(--bs-success)',
                'text-align': 'center',
                'vertical-align': 'middle',
                'border': '1px solid',
                'border-radius': '5px',
              };
            } else {
              // 'In Progress' Open not yet resolved
              return {
                'background-color': 'var(--bs-white)',
                'color': 'var(--bs-primary)',
                'text-align': 'center',
                'vertical-align': 'middle',
                'border': '1px solid',
                'border-radius': '5px',
              };
            }
          } else {
            // Completed and report sent
            return {
              'background-color': 'var(--bs-success)',
              'color': 'var(--bs-white)',
              'text-align': 'center',
              'vertical-align': 'middle',
              'border': '1px solid',
              'border-radius': '5px',
            };
          }
        },
      },
    ];
    if (this.isAdmin || this.isDispatchUser) {
      // add created user to list view
      tableDetails.splice(-2, 0, {
        header: 'Guard',
        name: 'created_user',
        sortKey: 'created_user',
        searchKey: 'created_user',
      });
      mobileCardDetails.push({
        name: 'created_user',
      });
    }

    updateCustomTableHeaders(tableDetails, this.searchParamsIncidents);

    this.incidentListTableDetails = [...tableDetails];
    this.incidentCardDetails.individualDetails = [...mobileCardDetails];
  }
  filterIncidents(filterString: string) {
    this.selectedFilter = filterString;
    this.getIncidents();
  }
}
